import React, { useState } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import { useArticleHierarchy } from "../utils/article-hierarchy";

export const Breadcrumbs: React.FC<{
  id?: string;
  mainCategoryId?: string;
  label?: string;
}> = ({ id, mainCategoryId, label, ...props }) => {
  const [hide, setHide] = React.useState(false);
  const scrollRef = React.useRef<null | number>(null);
  const { hierarchy, getAncestorsForArticleId, getMainCategory } =
    useArticleHierarchy();
  // console.log({ hierarchy });
  const ancestors = id ? getAncestorsForArticleId(id) : [];
  const subCategory = ancestors.length
    ? ancestors[ancestors.length - 1].type === "subCategory"
      ? ancestors[ancestors.length - 1]
      : null
    : null;
  const mainCategory = mainCategoryId ? getMainCategory(mainCategoryId) : null;

  React.useEffect(() => {
    window.addEventListener("scroll", () => {
      if (scrollRef.current === null) scrollRef.current = window.scrollY;
      if (window.scrollY > scrollRef.current) {
        setHide(true);
      } else {
        setHide(false);
      }
      scrollRef.current = window.scrollY;
    });
    return () => {
      window.removeEventListener("scroll", () => {
        // console.log(window.scrollY);
      });
    };
  }, []);
  const translateClass = hide ? "-mr-24" : "-mr-3";
  const parentTranslateClass = hide ? "translate-x-[-800px]" : "translate-x-0";
  const [isMainCategoryMenuOpen, setIsMainCategoryOpen] = useState(false);
  return (
    <div {...props}>
      <ul
        className={`
          fixed
          left-0
          top-12
          z-10
          mt-20
          flex
          h-12
          flex-row-reverse
          transition-all
          duration-1000
          lg:top-24
          lg:h-16
          ${parentTranslateClass}
        `}
      >
        {ancestors &&
          ancestors.map(
            (ancestor, i) =>
              (ancestors.length < 5 || i < 3 || i > ancestors.length - 3) && (
                <li
                  key={`breadcrumb-ancestor-${ancestor.id || i}`}
                  className={`
                duration-800
                relative
                -left-3
                flex
                items-center
                justify-center
                rounded-r-2xl
                border
                border-l-0
                border-beige
                pl-6
                pr-3
                text-sm
                font-bold
                text-beige
                transition-all
                ${translateClass}
                ${i === ancestors.length - 1 ? "pl-8" : ""} ${
                  i === 0 ? "bg-beige text-white" : "bg-light-gray"
                }
                ${
                  !(ancestors.length < 3 || i < 2 || i > ancestors.length - 2)
                    ? "max-w-[10px] hover:max-w-[150px]"
                    : ""
                }
              `}
                >
                  <a
                    href={
                      ancestor.type === "article"
                        ? `/article/${ancestor.slug}`
                        : `/${
                            ancestor.main_category
                              ? ancestor.main_category.slug
                              : "no-main-category"
                          }/${ancestor.slug}`
                    }
                    className={`line-clamp-1 max-w-[150px] underline underline-offset-1 `}
                    title={
                      ancestor.type === "article"
                        ? ancestor.Page_title
                        : ancestor.name
                    }
                  >
                    {ancestor.type === "article"
                      ? ancestor.Page_title
                      : ancestor.name}
                  </a>
                </li>
              ),
          )}
        {(subCategory || mainCategory || label) && (
          <li
            className={`
              z-10
              flex
              h-12
              cursor-pointer
              items-center
              rounded-r-2xl
              border
              border-l-0
              border-beige
              bg-white
              pl-4
              pr-3
              text-lg
              font-bold
              transition-all
              duration-1000
              lg:h-16
              lg:px-4
              lg:text-2xl
              ${translateClass}
            `}
            onClick={() => setIsMainCategoryOpen((open) => !open)}
          >
            {mainCategory
              ? mainCategory.name
              : subCategory && subCategory.main_category
              ? subCategory.main_category.name
              : label
              ? label
              : "NO MAIN CATEGORY"}{" "}
            {isMainCategoryMenuOpen && (
              <ChevronUpIcon className="relative top-1 ml-2 w-6 text-beige lg:w-8 " />
            )}
            {!isMainCategoryMenuOpen && (
              <ChevronDownIcon className="relative top-1 ml-2 w-6 text-beige lg:w-8 " />
            )}
          </li>
        )}
      </ul>
      {isMainCategoryMenuOpen && (
        <ul
          className={`
            fixed
            left-0
            top-44
            z-10
            mt-[-1px]
            flex
            flex-col
            items-start
            transition-all
            duration-1000
            lg:top-60
            ${parentTranslateClass}
          `}
        >
          {Object.keys(hierarchy).map((key) => {
            const currentMainCategory = hierarchy[key];
            if (subCategory && !subCategory.main_category) return null;
            if (subCategory && key === subCategory.main_category.id)
              return null;
            if (mainCategory && key === mainCategory.id) return null;
            if (
              label &&
              currentMainCategory &&
              currentMainCategory.name === label
            )
              return null;
            return (
              <li
                key={`breadcrumb-main-cat-${currentMainCategory.slug}`}
                className={`
                  z-10
                  mb-[-1px]
                  flex
                  h-12
                  items-center
                  rounded-r-2xl
                  border
                  border-l-0
                  border-beige
                  bg-white
                  px-4
                  text-lg
                  font-bold
                  transition-all
                  duration-1000
                  lg:h-16
                  lg:text-2xl
                  ${translateClass}
                `}
              >
                <a href={`/#${currentMainCategory.slug}`}>
                  {currentMainCategory.name}
                </a>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};
